import "./App.css";
import { MainRoutes } from "./Pages/MainRoutes";

function App() {
  return (
    <div>
      <MainRoutes />
    </div>
  );
}

export default App;
